module.exports = __webpack_public_path__ + "img/img-11.a280819b.png";